import React from 'react';
import { Check } from 'lucide-react';

interface Plan {
  id: string;
  name: string;
  price: string;
  features: string[];
}

interface PlanSelectionProps {
  selectedPlan: string;
  onPlanSelect: (planId: string) => void;
}

export const PlanSelection: React.FC<PlanSelectionProps> = ({ selectedPlan, onPlanSelect }) => {
  const plans: Plan[] = [
    {
      id: 'basic',
      name: 'Basic',
      price: '99€/mois',
      features: [
        'Jusqu\'à 100 utilisateurs',
        'Authentification simple',
        'Support par email',
      ],
    },
    {
      id: 'premium',
      name: 'Premium',
      price: '299€/mois',
      features: [
        'Jusqu\'à 1000 utilisateurs',
        'Authentification double facteur',
        'Support prioritaire',
        'API personnalisée',
      ],
    },
    {
      id: 'enterprise',
      name: 'Enterprise',
      price: 'Sur mesure',
      features: [
        'Utilisateurs illimités',
        'Solutions sur mesure',
        'Support dédié 24/7',
        'Intégration personnalisée',
        'SLA garanti',
      ],
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      {plans.map((plan) => (
        <div
          key={plan.id}
          className={`relative p-6 rounded-lg border-2 transition-all cursor-pointer
            ${selectedPlan === plan.id 
              ? 'border-indigo-600 shadow-lg' 
              : 'border-gray-200 hover:border-indigo-300'}`}
          onClick={() => onPlanSelect(plan.id)}
        >
          {selectedPlan === plan.id && (
            <div className="absolute top-4 right-4">
              <Check className="h-6 w-6 text-indigo-600" />
            </div>
          )}
          <h3 className="text-xl font-bold text-gray-900">{plan.name}</h3>
          <p className="mt-2 text-2xl font-semibold text-indigo-600">{plan.price}</p>
          <ul className="mt-6 space-y-4">
            {plan.features.map((feature, index) => (
              <li key={index} className="flex items-center">
                <Check className="h-5 w-5 text-indigo-500 mr-2" />
                <span className="text-gray-600">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};